const colorVars = {
  '--color-primary-200': '#103976',
  '--color-primary-150': '#145CC5',
  '--color-primary-100': '#2075F0',
  '--color-primary-80': '#2B7BEF',
  '--color-primary-50': '#5E9FFF',
  '--color-primary-30': '#BAD5FC',
  '--color-primary-20': '#D4E5FE',
  '--color-primary-10': '#EBF3FF',
  '--color-tertiary-200': '#020E1E',
  '--color-tertiary-150': '#061528',
  '--color-tertiary-100': '#0C1F38',
  '--color-tertiary-90': '#13253D',
  '--color-tertiary-80': '#172940',
  '--color-tertiary-20': '#22354F',
  '--color-secondary-150': '#389CFF',
  '--color-secondary-100': '#5FAFFF',
  '--color-secondary-50': '#8FC7FF',
  '--color-secondary-10': '#E9F4FC',
  '--color-neutral-black100': '#000000',
  '--color-neutral-black26': '#00000026',
  '--color-neutral-white100': '#FFFFFF',
  '--color-neutral-background10': '#F1F5FE',
  '--color-grays-100': '#0D1321',
  '--color-grays-90': '#231F20',
  '--color-grays-80': '#2F3440',
  '--color-grays-70': '#596379',
  '--color-grays-60': '#7E89A1',
  '--color-grays-50': '#8691A8',
  '--color-grays-45': '#BAC3D6',
  '--color-grays-40': '#D1D9E9',
  '--color-grays-30': '#ECEFF5',
  '--color-grays-20': '#F5F7FB',
  '--color-grays-10': '#FAFBFE',
  '--color-grays-5': '#F3F7FE',
  '--color-success-200': '#0E4B28',
  '--color-success-150': '#325B3A',
  '--color-success-100': '#50AB62',
  '--color-success-50': '#86D684',
  '--color-success-30': '#A9E2A7',
  '--color-success-10': '#E7F8E6',
  '--color-success-8': '#E9FCE9',
  '--color-error-200': '#490A0A',
  '--color-error-150': '#DA5847',
  '--color-error-100': '#FC7361',
  '--color-error-50': '#FF8777',
  '--color-error-20': '#FADEDA',
  '--color-error-10': '#FFEFED',
  '--color-warning-200': '#43260B',
  '--color-warning-150': '#FA8E2B',
  '--color-warning-100': '#FFA450',
  '--color-warning-50': '#FFBB7C',
  '--color-warning-10': '#FFF0E1',
  '--color-warning-8': '#FFF4EA',
  '--color-warning-5': '#FFE5BD',
  '--color-helpAndSupport-gray150': '#A5AFC3',
  '--color-helpAndSupport-gray200': '#7E89A1',
  '--color-helpAndSupport-darkGray': '#2F3440',
  '--color-decorative-terraCotta': '#ED6C5B',
  '--color-decorative-seaSerpent': '#5BC7E2',
  '--color-decorative-coolPurple': '#B024F6',
  '--color-decorative-coolPurple10': '#FAEFFF',
  '--color-decorative-coolPurple20': '#EFD0FF',
  '--color-decorative-coolPurple100': '#310C44',
  '--color-decorative-coolPurple150': '#691195',
  '--color-decorative-malachiteGreen': '#72DC90',
  '--color-decorative-navel': '#EE8332',
  '--color-decorative-homeAlert': '#FFF4EC',
  '--color-decorative-liveColor': '#FF6161',
  '--color-decorative-steelblue-translucent': '#4A81B824',
  '--color-decorative-steelblue-solid': '#4A81B8',
  '--color-decorative-green10': '#BBFFCE',
  '--color-decorative-orange10': '#FFEDCB',
  '--color-decorative-red10': '#FFDCDC',
  '--color-decorative-purple10': '#E4D8FF',
  '--color-decorative-splash': '#2675e8',
  '--color-decorative-Purple200': '#310C44',
  '--color-decorative-bee-150': '#412d09',
  '--color-decorative-bee-100': '#ffb000',
  '--color-decorative-bee-50': '#f4bc53',
  '--color-decorative-bee-20': '#fee6ba',
  '--color-decorative-bee-10': '#fff4e0',
  '--color-decorative-bee100': '#ffb000',
  '--color-tag-shade1': '#EEE3FF',
  '--color-tag-shade2': '#FFDFCD',
  '--color-lead-subAgentLead': '#2B4466',
  '--color-magnet-primary-10': '#F5ECFA',
  '--color-slate-100': '#F1F5F9',
}

module.exports = colorVars
